// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"197":"75fc9c18","293":"component---src-pages-index-js","461":"b637e9a5","518":"8a28b14e"}[chunkId] || chunkId) + "." + {"197":"10464323e5c148c16f8c","293":"bfdf8ecf83827da6691e","461":"1e33413f7811cb92191a","518":"fdb5c3e5f62871ba1fef","779":"dd4f8e9a4f7b1bb36a48"}[chunkId] + ".js";
};